import * as React from 'react';
import { NavDropdown, NavDropdownProps, Dropdown } from 'react-bootstrap';
import { ReplaceProps } from 'react-bootstrap/helpers';

interface INavItemState
{
	show: boolean;
}

class NavItem extends React.Component<ReplaceProps<typeof Dropdown, NavDropdownProps>, INavItemState>
{
	state =
	{
		show: false
	};

	render()
	{
		const { show } = this.state;
		const {  onMouseEnter, onMouseLeave  } = this.props;
		return (
			<NavDropdown {...this.props}
				show={show}
				onMouseEnter={ () => this.setState({ show: true  }) }
				onMouseLeave={ () => this.setState({ show: false }) }
				>
				{ this.props.children }
			</NavDropdown>
		)
	}
}

export default NavItem;
